import { inject, Injectable } from '@angular/core';

import { ToastData, ToastService, ToastType } from '@hglobal/common';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class GlobalToastService {
  readonly #toast = inject(ToastService);
  readonly #translate = inject(TranslateService);

  showSuccess(message = 'toast.dialog.success.message'): void {
    this.#toast.show({
      message: this.#translate.instant(message),
      type: ToastType.Success,
    });
  }

  showSuccessWithTitle(message = 'toast.dialog.success.message', title = 'toast.dialog.success.title'): void {
    this.#toast.show({
      title: this.#translate.instant(title),
      message: this.#translate.instant(message),
      type: ToastType.Success,
    });
  }

  showErrorWithTitle(message: string, title = 'toast.dialog.error.title'): void {
    this.#toast.show({
      title: this.#translate.instant(title),
      message,
      type: ToastType.Error,
    });
  }

  showError(message: string): void {
    this.#toast.show({
      message,
      type: ToastType.Error,
    });
  }

  showInfo(message: string): void {
    this.#toast.show({
      message,
      type: ToastType.Info,
    });
  }

  showCustom(config: ToastData): void {
    this.#toast.show(config);
  }
}
